import { Injectable } from '@angular/core';
import { BaseViewConfigService, CartConfigService, CartRow, CartService, ProductAssortmentParentService } from 'gung-standard';
import { ListLayoutMultipleComponent, ListLayout } from 'gung-list';
import { SjoborgCartListComponent } from '../components/checkout/sjoborg-cart-list/sjoborg-cart-list.component';

@Injectable({
  providedIn: 'root'
})
export class SjoborgCartConfigService extends CartConfigService {
  constructor(
    cartService: CartService,     
    protected baseViewConfigService: BaseViewConfigService,
    protected productAssortmentParentService: ProductAssortmentParentService
    ) {
    super(cartService, baseViewConfigService, productAssortmentParentService);
  }

  getLayouts(): ListLayout<CartRow>[] {
    return [
      {
        getIconClass: () => '',
        getName: () => 'Cart grid',
        getListItemComponent: () => SjoborgCartListComponent,
        getListLayoutComponent: () => ListLayoutMultipleComponent
      }
    ];
  }
}
